import type { PageContext } from '../types/agent.types';

interface ExtractedContext extends PageContext {
  label: string;
}

const ROUTE_MAP: { pattern: RegExp; page: string; label: string }[] = [
  { pattern: /^\/[a-z]{2}\/my-orders\/([^/]+)$/, page: 'order_detail', label: 'Order Details' },
  { pattern: /^\/[a-z]{2}\/my-orders\/?$/, page: 'orders', label: 'My Orders' },
  { pattern: /^\/[a-z]{2}\/my-searches\/([^/]+)$/, page: 'search_detail', label: 'Search Details' },
  { pattern: /^\/[a-z]{2}\/my-searches\/?$/, page: 'searches', label: 'My Searches' },
  { pattern: /^\/[a-z]{2}\/projects\/([^/]+)$/, page: 'project_detail', label: 'Project' },
  { pattern: /^\/[a-z]{2}\/projects\/?$/, page: 'projects', label: 'Projects' },
  { pattern: /^\/[a-z]{2}\/archive-search\/?/, page: 'archive_search', label: 'Archive Search' },
  { pattern: /^\/[a-z]{2}\/tasking\/?/, page: 'tasking', label: 'Tasking' },
  { pattern: /^\/[a-z]{2}\/account\/?/, page: 'account', label: 'Account' },
  { pattern: /^\/[a-z]{2}\/?$/, page: 'dashboard', label: 'Dashboard' },
  // Routes without locale prefix (Hub layout)
  { pattern: /^\/data-management\/?$/, page: 'data_management', label: 'Data Management' },
  { pattern: /^\/product-library\/?/, page: 'product_library', label: 'Product Library' },
  { pattern: /^\/projects\/([^/]+)$/, page: 'project_detail', label: 'Project' },
  { pattern: /^\/projects\/?$/, page: 'projects', label: 'Projects' },
  { pattern: /^\/approvals\/?/, page: 'approvals', label: 'Approvals' },
  { pattern: /^\/metrics\/?/, page: 'metrics', label: 'Metrics' },
  { pattern: /^\/organization\/?/, page: 'organization', label: 'Organization' },
  // Root path — Order Imagery in Hub (must be last)
  { pattern: /^\/$/, page: 'order_imagery', label: 'Order Imagery' },
];

export function extractPageContext(pathname: string): ExtractedContext {
  for (const route of ROUTE_MAP) {
    const match = pathname.match(route.pattern);
    if (match) {
      const context: ExtractedContext = { page: route.page, label: route.label };

      // Extract dynamic IDs from capture groups
      if (match[1]) {
        if (route.page === 'order_detail') context.orderId = match[1];
        else if (route.page === 'search_detail') context.searchId = match[1];
        else if (route.page === 'project_detail') context.projectId = match[1];
      }

      return context;
    }
  }

  return { page: 'unknown', label: 'Hub' };
}
